import { TierFeatureInTier } from '@/pages/unauthenticated/pricing/components/tier-comparisons/shared/tier.feature-in-tier';
import {
  PlatformFeature,
  PricingTier,
} from '@/pages/unauthenticated/pricing/components/types';

interface TierGridCellsProps {
  feature: PlatformFeature;
  tier: PricingTier;
  tiers: PricingTier[];
}

export const TierGridCells = ({ feature, tier }: TierGridCellsProps) => {
  return (
    <>
      <dt className="pr-4">{feature.name}</dt>
      <dd className="flex items-center justify-end sm:justify-center sm:px-4">
        <TierFeatureInTier feature={feature} tier={tier} />
        <span className="sr-only">
          {feature.tiers[tier.name] === true ? 'Yes' : 'No'}
        </span>
      </dd>
    </>
  );
};
